export const rtNotificationsConstants = {
    RT_NOTIFICATION_RECEIVED: "RT_NOTIFICATION_RECEIVED",
    RT_NOTIFICATION_DISMISSED: "RT_NOTIFICATION_DISMISSED",
    RT_NOTIFICATION_CONFIRMED: "RT_NOTIFICATION_CONFIRMED",
    RT_NOTIFICATION_CLEAR: "RT_NOTIFICATION_CLEAR",
};
